(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dogtopus-oct-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.vl-dogtopus-hero-section').forEach((root) => {
      const items = root.querySelectorAll('[data-vl-reveal]');
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        items.forEach((item) => item.classList.add('vl-is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('vl-is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      items.forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dogtopus-oct-oct"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>document.querySelectorAll('[data-vl-choose-pack]').forEach(link=>{if(link.dataset.bound)return;link.dataset.bound='true';link.addEventListener('click',e=>{const target=[...document.querySelectorAll('input[type="radio"][form^="product-form-"]')].find(input=>input.value===link.dataset.optionValue);const feedback=document.querySelector('[data-vl-pack-feedback]');if(target){target.click();const label=document.querySelector('label[for="'+CSS.escape(target.id)+'"]');label?.focus({preventScroll:true});if(feedback)feedback.textContent='Pack selected. Add it to your cart in the purchase form.';}else{if(feedback)feedback.textContent='Choose your pack in the purchase form.';}});});init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dogtopus-oct-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const moveTo = (track, card) => { if(card) track.scrollTo({left:track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left,behavior:reducedMotion()?'auto':'smooth'}); };
  const autoAdvance = (track, cards) => {
    if(reducedMotion()||cards.length<2||track.dataset.autoReady)return;
    track.dataset.autoReady='true';
    let timer;
    const current=()=>{let selected=0,distance=Infinity;cards.forEach((card,index)=>{const delta=Math.abs(card.getBoundingClientRect().left-track.getBoundingClientRect().left);if(delta<distance){distance=delta;selected=index;}});return selected;};
    const start=()=>{window.clearInterval(timer);timer=window.setInterval(()=>{if(!document.hidden)moveTo(track,cards[(current()+1)%cards.length]);},4500);};
    const stop=()=>window.clearInterval(timer);
    track.addEventListener('mouseenter',stop);track.addEventListener('mouseleave',start);track.addEventListener('focusin',stop);track.addEventListener('focusout',start);track.addEventListener('pointerdown',stop,{passive:true});track.addEventListener('pointerup',start,{passive:true});document.addEventListener('visibilitychange',()=>document.hidden?stop():start());start();
  };
  const bindCarousel = (track, cards, previous, next, pages, status, compact=false) => {
    let pageCount=0, perPage=1;
    const visible=()=>cards.filter(card=>!card.hidden);
    const page=()=>{const items=visible();if(!items.length)return 0;const gap=parseFloat(getComputedStyle(track).columnGap)||0;const unit=items[0].getBoundingClientRect().width+gap;const maximum=Math.max(0,track.scrollWidth-track.clientWidth);let nearest=0,distance=Infinity;for(let i=0;i<pageCount;i++){const delta=Math.abs(track.scrollLeft-Math.min(maximum,i*unit*perPage));if(delta<distance){distance=delta;nearest=i;}}return nearest;};
    const go=index=>moveTo(track,visible()[Math.max(0,Math.min(pageCount-1,index))*perPage]);
    const update=()=>{const items=visible();const current=page();if(previous)previous.disabled=compact?pageCount<2:current<=0;if(next)next.disabled=compact?pageCount<2:current>=pageCount-1;if(compact)items.forEach((card,index)=>{const active=index===current;card.classList.toggle('is-active',active);if(active)card.setAttribute('aria-current','true');else card.removeAttribute('aria-current');});pages?.querySelectorAll('button').forEach((button,index)=>{if(index===current)button.setAttribute('aria-current','page');else button.removeAttribute('aria-current');});if(status)status.textContent=items.length?(compact?(current+1)+' / '+pageCount:(Math.min(current*perPage,Math.max(0,items.length-perPage))+1)+'-'+Math.min(items.length,Math.min(current*perPage,Math.max(0,items.length-perPage))+perPage)+' of '+items.length+' reviews'):'0 reviews';};
    const layout=()=>{const items=visible();if(!items.length){pageCount=0;pages?.replaceChildren();update();return;}const gap=parseFloat(getComputedStyle(track).columnGap)||0;perPage=compact?1:Math.max(1,Math.floor((track.clientWidth+gap)/(items[0].getBoundingClientRect().width+gap)));pageCount=Math.ceil(items.length/perPage);if(pages){pages.replaceChildren();for(let i=0;i<pageCount;i++){const button=document.createElement('button');button.type='button';button.textContent=String(i+1);button.setAttribute('aria-label','Review page '+(i+1)+' of '+pageCount);button.setAttribute('aria-controls',track.id);button.addEventListener('click',()=>go(i));pages.append(button);}}items.forEach((card,index)=>card.setAttribute('aria-label','Review '+(index+1)+' of '+items.length));update();};
    previous?.addEventListener('click',()=>go(compact?(page()-1+pageCount)%pageCount:page()-1));next?.addEventListener('click',()=>go(compact?(page()+1)%pageCount:page()+1));
    track.addEventListener('scroll',update,{passive:true});track.addEventListener('keydown',event=>{if(event.target!==track)return;const keys=['ArrowLeft','ArrowRight','Home','End'];if(!keys.includes(event.key))return;event.preventDefault();if(event.key==='Home')go(0);else if(event.key==='End')go(pageCount-1);else go(page()+(event.key==='ArrowRight'?1:-1));});
    if('ResizeObserver' in window){const observer=new ResizeObserver(layout);observer.observe(track);}else window.addEventListener('resize',layout);
    layout();return layout;
  };
  const buildHighlights=()=>{
    const root=document.querySelector('[data-vl-reviews-root]');
    const cards=root?[...root.querySelectorAll('[data-vl-review-card]')]:[];
    const used=new Set([...document.querySelectorAll('[data-media-key]')].map(media=>media.dataset.mediaKey).filter(Boolean));
    document.querySelectorAll('[data-vl-mini-reviews]').forEach((slot,index)=>{
      if(!cards.length){const track=slot.querySelector('.vl-mini-review-track');const miniCards=track?[...track.children]:[];if(track&&miniCards.length&&!track.dataset.bound){track.dataset.bound='true';bindCarousel(track,miniCards,slot.querySelector('[data-vl-mini-prev]'),slot.querySelector('[data-vl-mini-next]'),null,slot.querySelector('[data-vl-mini-status]'),true);autoAdvance(track,miniCards);}slot.hidden=false;return;}
      slot.replaceChildren();slot.hidden=true;
      const track=document.createElement('div');track.className='vl-mini-review-track';track.id='vl-mini-review-track-'+index;track.tabIndex=0;track.setAttribute('role','region');track.setAttribute('aria-roledescription','carousel');track.setAttribute('aria-label','Dog-parent review highlights');
      cards.forEach(card=>{
        if(track.children.length>=4)return;
        const photo=card.querySelector('[data-vl-highlight-photo]');const key=photo?.dataset.photoKey;const hasPhoto=Boolean(photo&&key&&!used.has(key));
        const mini=document.createElement('article');mini.className='vl-mini-review vl-mini-review--quote'+(hasPhoto?' vl-mini-review--photo':'');mini.setAttribute('role','group');mini.setAttribute('aria-roledescription','review');
        if(hasPhoto){used.add(key);mini.append(photo.content.cloneNode(true));}
        const copy=document.createElement('div');copy.className='vl-mini-review-copy';
        const quote=document.createElement('blockquote');const full=card.querySelector('[data-vl-review-quote]').textContent;quote.textContent=full.length>190?full.slice(0,187)+'…':full;
        const identity=document.createElement('div');identity.className='vl-mini-review-identity';identity.append(card.querySelector('[data-vl-review-name]').cloneNode(true));const dog=card.querySelector('[data-vl-review-dog]');if(dog)identity.append(dog.cloneNode(true));
        copy.append(quote,identity);mini.append(copy);track.append(mini);
      });
      if(!track.children.length)return;
      const controls=document.createElement('div');controls.className='vl-mini-review-controls';const link=document.createElement('a');link.href='#dogtopus-reviews';link.textContent='See all reviews';controls.append(link);const buttons=document.createElement('div');const previous=document.createElement('button'),next=document.createElement('button'),status=document.createElement('output');status.setAttribute('aria-live','polite');[previous,next].forEach(button=>{button.type='button';button.setAttribute('aria-controls',track.id);});previous.textContent='←';previous.setAttribute('aria-label','Previous review');next.textContent='→';next.setAttribute('aria-label','Next review');buttons.append(previous,status,next);controls.append(buttons);slot.append(track,controls);slot.hidden=false;const miniCards=[...track.children];bindCarousel(track,miniCards,previous,next,null,status,true);autoAdvance(track,miniCards);
    });
    document.querySelectorAll('[data-vl-review-avatars]').forEach(slot=>{slot.replaceChildren();slot.hidden=true;cards.forEach(card=>{if(slot.children.length>=4)return;const photo=card.querySelector('[data-vl-avatar-photo]');const key=photo?.dataset.photoKey;if(!photo||!key||used.has(key))return;used.add(key);slot.append(photo.content.cloneNode(true));});slot.hidden=!slot.children.length;});
  };
  const setup=()=>{
    document.querySelectorAll('[data-vl-reviews-root]').forEach(root=>{
      if(root.dataset.ready)return;root.dataset.ready='true';const track=root.querySelector('[data-vl-review-track]');const cards=[...root.querySelectorAll('[data-vl-review-card]')];if(!track||!cards.length)return;
      const navigation=root.querySelector('[data-vl-review-nav]');navigation.hidden=false;
      const layout=bindCarousel(track,cards,root.querySelector('[data-vl-review-prev]'),root.querySelector('[data-vl-review-next]'),root.querySelector('[data-vl-review-pages]'),root.querySelector('[data-vl-review-status]'));
      root.querySelectorAll('[data-vl-review-filter]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-vl-review-filter]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));cards.forEach(card=>{card.hidden=button.dataset.vlReviewFilter==='photo'?card.dataset.hasPhoto!=='true':button.dataset.vlReviewFilter==='video'?card.dataset.hasVideo!=='true':false;if(card.hidden)card.querySelectorAll('video').forEach(video=>video.pause());});track.scrollLeft=0;layout();}));
      const measureQuotes=()=>cards.forEach(card=>{const quote=card.querySelector('[data-vl-review-quote]'),button=card.querySelector('[data-vl-review-expand]');if(!quote.classList.contains('is-expanded'))button.hidden=quote.scrollHeight<=quote.clientHeight+2;});
      cards.forEach(card=>{const quote=card.querySelector('[data-vl-review-quote]'),button=card.querySelector('[data-vl-review-expand]');button.addEventListener('click',()=>{const expanded=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(expanded));button.textContent=expanded?'Show less':'Read full review';quote.classList.toggle('is-expanded',expanded);});});
      measureQuotes();document.fonts?.ready.then(measureQuotes);if('ResizeObserver' in window)new ResizeObserver(measureQuotes).observe(track);
      root.querySelectorAll('video').forEach(video=>{video.addEventListener('play',()=>document.querySelectorAll('.vl-review-video video,.vl-purchase-videos video').forEach(other=>{if(other!==video)other.pause();}));if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)video.pause();}),{threshold:.1});observer.observe(video);}});
    });
    buildHighlights();
  };
  setup();document.addEventListener('shopify:section:load',setup);document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(setup));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dogtopus-oct-sales-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = () => {
    const roots = document.querySelectorAll('.vl-dogtopus-sales-page-section');
    roots.forEach((root) => {
      if (root.dataset.vlReady === 'true') return;
      root.dataset.vlReady = 'true';
      const revealItems = root.querySelectorAll('[data-vl-reveal]');
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        revealItems.forEach((item) => item.classList.add('vl-is-visible'));
      } else {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('vl-is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1 });
        revealItems.forEach((item) => observer.observe(item));
      }

      root.querySelectorAll('[data-vl-carousel]').forEach((carousel) => {
        const section = carousel.closest('.vl-stage');
        const previous = section && section.querySelector('[data-vl-carousel-prev]');
        const next = section && section.querySelector('[data-vl-carousel-next]');
        const move = () => Math.max(280, carousel.clientWidth * .82);
        if (previous) previous.addEventListener('click', () => carousel.scrollBy({ left: -move(), behavior: 'smooth' }));
        if (next) next.addEventListener('click', () => carousel.scrollBy({ left: move(), behavior: 'smooth' }));
      });

      root.querySelectorAll('.vl-video-toggle').forEach((button) => {
        const video = button.parentElement.querySelector('video');
        const setPlayingState = (playing) => {
          button.parentElement.classList.toggle('is-playing', playing);
          button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
          button.querySelector('span').textContent = playing ? 'Ⅱ' : '▶';
        };
        button.addEventListener('click', () => {
          if (video.paused) {
            root.querySelectorAll('.vl-demo-video video').forEach((other) => { if (other !== video) other.pause(); });
            video.play();
            setPlayingState(true);
          } else {
            video.pause();
            setPlayingState(false);
          }
        });
        video.addEventListener('pause', () => setPlayingState(false));
        video.addEventListener('play', () => setPlayingState(true));
      });

      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const videos = root.querySelectorAll('.vl-demo-video video');
        const videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= .72) {
              videos.forEach((other) => { if (other !== entry.target) other.pause(); });
              entry.target.play().catch(() => {});
            } else if (!entry.isIntersecting) {
              entry.target.pause();
            }
          });
        }, { threshold: [0, .72] });
        videos.forEach((video) => videoObserver.observe(video));
      }

      const progress = root.querySelector('.vl-progress span');
      const updateProgress = () => {
        if (!progress) return;
        const page = document.documentElement;
        const maximum = page.scrollHeight - window.innerHeight;
        progress.style.width = `${maximum > 0 ? Math.min(100, (window.scrollY / maximum) * 100) : 0}%`;
      };
      updateProgress();
      window.addEventListener('scroll', updateProgress, { passive: true });
    });
    };
    setup();
    document.addEventListener('shopify:section:load', setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["furreset-brand-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.vl-dogtopus-hero-section').forEach((root) => {
      const items = root.querySelectorAll('[data-vl-reveal]');
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        items.forEach((item) => item.classList.add('vl-is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('vl-is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      items.forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["furreset-brand-offer"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>document.querySelectorAll('[data-vl-choose-pack]').forEach(link=>{if(link.dataset.bound)return;link.dataset.bound='true';link.addEventListener('click',e=>{const target=[...document.querySelectorAll('input[type="radio"][form^="product-form-"]')].find(input=>input.value===link.dataset.optionValue);const feedback=document.querySelector('[data-vl-pack-feedback]');if(target){target.click();const label=document.querySelector('label[for="'+CSS.escape(target.id)+'"]');label?.focus({preventScroll:true});if(feedback)feedback.textContent='Pack selected. Add it to your cart in the purchase form.';}else{if(feedback)feedback.textContent='Choose your pack in the purchase form.';}});});init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["furreset-brand-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = () => {
    const roots = document.querySelectorAll('.vl-dogtopus-sales-page-section');
    roots.forEach((root) => {
      if (root.dataset.vlReady === 'true') return;
      root.dataset.vlReady = 'true';
      const revealItems = root.querySelectorAll('[data-vl-reveal]');
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        revealItems.forEach((item) => item.classList.add('vl-is-visible'));
      } else {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('vl-is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1 });
        revealItems.forEach((item) => observer.observe(item));
      }

      root.querySelectorAll('[data-vl-carousel]').forEach((carousel) => {
        const section = carousel.closest('.vl-stage');
        const previous = section && section.querySelector('[data-vl-carousel-prev]');
        const next = section && section.querySelector('[data-vl-carousel-next]');
        const move = () => Math.max(280, carousel.clientWidth * .82);
        if (previous) previous.addEventListener('click', () => carousel.scrollBy({ left: -move(), behavior: 'smooth' }));
        if (next) next.addEventListener('click', () => carousel.scrollBy({ left: move(), behavior: 'smooth' }));
      });

      root.querySelectorAll('.vl-video-toggle').forEach((button) => {
        const video = button.parentElement.querySelector('video');
        const setPlayingState = (playing) => {
          button.parentElement.classList.toggle('is-playing', playing);
          button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
          button.querySelector('span').textContent = playing ? 'Ⅱ' : '▶';
        };
        button.addEventListener('click', () => {
          if (video.paused) {
            root.querySelectorAll('.vl-demo-video video').forEach((other) => { if (other !== video) other.pause(); });
            video.play();
            setPlayingState(true);
          } else {
            video.pause();
            setPlayingState(false);
          }
        });
        video.addEventListener('pause', () => setPlayingState(false));
        video.addEventListener('play', () => setPlayingState(true));
      });

      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const videos = root.querySelectorAll('.vl-demo-video video');
        const videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= .72) {
              videos.forEach((other) => { if (other !== entry.target) other.pause(); });
              entry.target.play().catch(() => {});
            } else if (!entry.isIntersecting) {
              entry.target.pause();
            }
          });
        }, { threshold: [0, .72] });
        videos.forEach((video) => videoObserver.observe(video));
      }

      const progress = root.querySelector('.vl-progress span');
      const updateProgress = () => {
        if (!progress) return;
        const page = document.documentElement;
        const maximum = page.scrollHeight - window.innerHeight;
        progress.style.width = `${maximum > 0 ? Math.min(100, (window.scrollY / maximum) * 100) : 0}%`;
      };
      updateProgress();
      window.addEventListener('scroll', updateProgress, { passive: true });
    });
    };
    setup();
    document.addEventListener('shopify:section:load', setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
